// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041705/js/" + chunkId + "." + {"44":"afd7b04f","225":"b40c1420","481":"e285813f","486":"0a4c875a","770":"74210098"}[chunkId] + ".0.8140531523927806.chunk.js";
};